import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { ICE_JOB_BASE_PATH } from '../../../../../../../../../features/vendor/ice/job/ice-job-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/job/_job')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'ice-job-list',
        label: 'ICE',
        to: ICE_JOB_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
